<!-- 在线客服 -->
<template>
  <div class="online-service">
    <div class="contact-us" @click="handleClick">
      <svg-icon class="img-contactus" name="ic_online_support" />
      <div class="title">
        <!-- 亚太/澳洲/土耳其/俄罗斯客服标题和按钮 -->
        {{
          isAsia()
            ? $t('support.online_server_asia')
            : $t('support.online_server')
        }}
      </div>
      <div class="desc">
        {{ $t('support.contact_us_tips') }}
      </div>
      <div class="view-now-box">
        {{
          isAsia() ? $t('support.online_chat_asia') : $t('support.online_chat')
        }}
      </div>
    </div>
    <div class="right-box">
      <img
        :alt="
          isAsia()
            ? $t('support.online_server_asia')
            : $t('support.online_server')
        "
        loading="lazy"
        class="right-img"
        :src="onlineServerImg" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useUrl } from '@support/json';
import {
  showOnlineChat,
  openInNewTabWithParams,
  environmentData,
  isAsia
} from '@support/utils';

const { $sensorTrack } = useNuxtApp();
const { t } = useI18n();
const { onlineServerImg, onlineServer } = useUrl();
const emits = defineEmits(['serviceClick']);
function handleClick() {
  $sensorTrack('self_service_click', {
    click_type: t('support.online_server')
  });
  emits('serviceClick');
  const flag = showOnlineChat();
  if (flag) {
    useWindowsOpen(onlineServer);
  } else {
    openInNewTabWithParams({
      path: '/onlineChat'
    });
  }
}
</script>
<style lang="scss" scoped>
.online-service {
  margin: 0 auto 0;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  // width: 1200px;
}
.contact-us {
  width: 590px;
  height: 280px;
  text-align: center;
  border-radius: 10px;
  background: #f3f6fa;
  .img-contactus {
    width: 80px;
    height: 80px;
    margin-top: 16px;
    margin-bottom: 24px;
  }
  .title {
    height: 30px;
    margin-bottom: 8px;
    font-size: 20px;
    font-weight: 500;
    color: #000000;
  }
  .desc {
    // width: 253px;
    height: 48px;
    margin: auto;
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    opacity: 0.5;
    padding: 0 16px;
  }
  .view-now-box {
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    line-height: 24px;
    margin-bottom: 30px;
  }
}
.contact-us:hover {
  cursor: pointer;

  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.1);
  transform: translateY(-10px);
  transition: all 0.15s ease-in-out;

  .view-now-box {
    color: #157be1;
    text-decoration: underline;
  }
}
.right-box {
  width: 590px;
  height: 280px;
  margin-left: 20px;
  border-radius: 10px;
  background: linear-gradient(91deg, #ebebeb 0%, #f5f5f5 100%);
  border-radius: 10px 10px 10px 10px;
  .right-img {
    width: 100%;
    border-radius: 10px;
  }
}
.no_data_server {
  .contact-us {
    width: 430px;
  }
  .right-box {
    width: 430px;
    position: relative;
    overflow: hidden;
    .right-img {
      width: 580px;
      position: absolute;
      left: -75px;
      top: 0;
      height: 100%;
    }
  }
}
</style>
